import logger from '@salesforce/retail-react-app/app/utils/logger-instance'

const cache = {}

const useSeoUrlMapping = () => {
    const getSeoUrlMapping = (api, token, urlMapping) => {
        if (urlMapping?.urlSegment) {
            if (cache[urlMapping.urlSegment]) {
                return cache[urlMapping.urlSegment]
            }
            cache[urlMapping.urlSegment] = fetchSeoUrlMapping(api, token, urlMapping)
            return cache[urlMapping.urlSegment]
        } else {
            return Promise.resolve(null)
        }
    }

    const fetchSeoUrlMapping = (api, token, urlMapping) => {
        try {
            const result = api.shopperSeo.getUrlMapping({
                parameters: urlMapping,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            if (result === null) {
                throw new Error('No URL mapping found')
            }

            return result
        } catch (error) {
            logger.error('Error fetching Url Mapping', {
                namespace: 'useSeoUrlMapping.getSeoUrlMapping',
                additionalProperties: {error: error}
            })
        }
    }

    return {getSeoUrlMapping}
}

export default useSeoUrlMapping
